import React from 'react'
import styled from 'styled-components'

import { theme, breakpoint } from '../styles'

import { SEO } from '../components'

import { MaxWidthWrapper } from '../components/layouts'

/* Containers  */
const TermsOfUsePageContainer = styled.section`
  background: ${theme.color.solid.white};
  color: ${theme.color.solid.pureblk};
`

const Wrapper = styled(MaxWidthWrapper)`
  margin: 0 auto;
  padding: 147px 8rem;

  @media (max-width: ${breakpoint.largeTablet}) {
    padding: 131px 7rem;
  }

  @media (max-width: ${breakpoint.largeMobile}) {
    padding: 67px 2.4rem;
  }
`
/* Headers */

const Header = styled.h2`
  text-align: center;
  margin-bottom: 0;

  @media (max-width: ${breakpoint.largeTablet}) {
    font-size: 3.8rem;
  }

  @media (max-width: ${breakpoint.largeMobile}) {
    font-size: 3.6rem;
  }
`

const LastModified = styled.h5`
  text-align: center;
  font-style: italic;
  margin-top: 8px;

  @media (max-width: ${breakpoint.largeTablet}) {
    font-size: 2.4rem;
  }

  @media (max-width: ${breakpoint.largeMobile}) {
    font-size: 1.4rem;
  }
`
/* Paragraphs */

const Paragraph = styled.p`
  font-size: 1.8rem;
  line-height: 3rem;

  @media (max-width: ${breakpoint.largeTablet}) {
    font-size: 1.4rem;
    line-height: 2.4rem;
  }

  @media (max-width: ${breakpoint.largeMobile}) {
    font-size: 1.2rem;
    line-height: 1.8rem;
  }
`

const TermsOfUsePage = () => (
  <>
    <SEO title="Terms of Use" />
    <TermsOfUsePageContainer>
      <Wrapper>
        <Header>Terms of Purchase and Service</Header>
        <LastModified>Last modified: August 1st, 2020</LastModified>
        <Paragraph>
          Welcome, and thank you for your interest in Katalyst, Inc.
          (“Katalyst,” “we,” or “us”) and our website at katalyst.fit, along
          with our related websites, networks, applications, mobile
          applications, and hardware products and accessories. These Terms of
          Purchase and Service are a legally binding contract between you and
          Katalyst regarding your purchase of our Components and your use of the
          Service. PLEASE READ THE FOLLOWING TERMS CAREFULLY.BY CLICKING “I
          ACCEPT,” “BUY,” “BUY NOW,” “PURCHASE,” OR BY DOWNLOADING, INSTALLING,
          OR OTHERWISE ACCESSING OR USING THE SERVICE, YOU AGREE THAT YOU HAVE
          READ AND UNDERSTOOD, AND, AS A CONDITION TO YOUR PURCHASES AND USE OF
          THE SERVICE, YOU AGREE TO BE BOUND BY, THE FOLLOWING TERMS AND
          CONDITIONS, INCLUDING KATALYST’S PRIVACY POLICY (TOGETHER, THESE
          “TERMS”). IF YOU ARE NOT ELIGIBLE OR DO NOT AGREE TO THE TERMS, THEN
          YOU SHOULD NOT PURCHASE ANY COMPONENTS AND YOU DO NOT HAVE OUR
          PERMISSION TO USE THE SERVICE. YOUR PURCHASE OF ANY COMPONENT AND YOUR
          USE OF THE SERVICE, AND KATALYST’S PROVISION OF ANY COMPONENT OR THE
          SERVICE TO YOU, CONSTITUTES AN AGREEMENT BY KATALYST AND BY YOU TO BE
          BOUND BY THESE TERMS.ARBITRATION NOTICE. Except for certain kinds of
          disputes described in Section 16, you agree that disputes arising
          under these Terms (including any dispute arising from your purchase or
          use of a Component) will be resolved by binding, individual
          arbitration, and BY ACCEPTING THESE TERMS, YOU AND KATALYST ARE EACH
          WAIVING THE RIGHT TO A TRIAL BY JURY OR TO PARTICIPATE IN ANY CLASS
          ACTION OR REPRESENTATIVE PROCEEDING. YOU AGREE TO GIVE UP YOUR RIGHT
          TO GO TO COURT to assert or defend your rights under this contract
          (except for matters that may be taken to small claims court). Your
          rights will be determined by a NEUTRAL ARBITRATOR and NOT a judge or
          jury. (See Section 16.)Katalyst Overview. Katalyst provides a power
          assisted training device comprised of a full-body suit (the “Suit”)
          integrated EMS technology (the “Impulse Pack”) and related accessories
          which may be offered by Katalyst from time to time (collectively, the
          “Component(s)”). To use certain features of the Component, you must
          connect to our service, which offers digital fitness and training
          content and various other features, including through a mobile
          application (collectively, the “Service”). The Component and Service
          are referred to collectively as the “Katalyst Training System”.Use of
          the Service
        </Paragraph>

        <Paragraph>
          2.1 Eligibility. You must be an adult to purchase and/or use the
          Katalyst Training System. By agreeing to these Terms, you represent
          and warrant to us that: (a) you are an adult (at least the age of
          majority in your jurisdiction); (b) you have not previously been
          suspended or removed from the Katalyst Training System, and (c) your
          registration and your use of the Katalyst Training System is in
          compliance with any and all applicable laws and regulations.
        </Paragraph>

        <Paragraph>
          2.2 Your Health. By accessing the Katalyst Training System, you
          acknowledge and agree that your performance of any and all exercises
          or activities recommended by the Katalyst Training System is wholly at
          your own risk. You acknowledge and agree that the Katalyst Training
          System is intended for use only by individuals healthy enough to
          perform strenuous exercise.
        </Paragraph>

        <Paragraph>
          a. You must not use the Katalyst Training System if any of the
          following are true:
        </Paragraph>

        <Paragraph>
          i. if you have a pacemaker (artificial pacemaker), implanted
          defibrillator, or other implanted metallic or electronic device. Such
          use could cause electric shock, burns, electrical interference, or
          death;
        </Paragraph>
        <Paragraph>ii. you are menstruating or pregnant;</Paragraph>
        <Paragraph>
          iii. you are experiencing extreme muscle strain or trauma, or if you
          are experiencing a muscle strain condition such as rhabdomyolysis;
        </Paragraph>
        <Paragraph>
          iv. you have been diagnosed with any heart problem or condition,
        </Paragraph>
        <Paragraph>
          v. you have an inadequate blood supply (ischemia) or a serious blood
          circulation disorder in the lower limbs;
        </Paragraph>
        <Paragraph>vi. you have an abdominal or groin hernia; or</Paragraph>
        <Paragraph>
          vii. you answered “yes”, “maybe” or “I don’t know” to one or more of
          the questions listed on page 2 of the Katalyst Instruction Manual;
        </Paragraph>

        <Paragraph>
          b. Before using the Katalyst Training System, we highly recommend you
          seek guidance from a qualified health care practitioner if you have
          any preexisting injuries or conditions that may interfere with
          recommended activities, or have any of the following:
        </Paragraph>

        <Paragraph>
          i. a tendency to bleed internally (hemorrhage) following trauma or
          fracture;
        </Paragraph>
        <Paragraph>
          ii. acute trauma or a fracture or following recent surgery when muscle
          contraction may disrupt the healing process;
        </Paragraph>
        <Paragraph>
          iii. been diagnosed with epilepsy or another neurological disorder;
        </Paragraph>
        <Paragraph>
          iv. nerve damage resulting in a lack of feeling in a particular area
          of the body;
        </Paragraph>
        <Paragraph>
          v. a loss of muscle tissue or muscle atrophy, experience muscle
          spasms, or have muscles associated with painful or afflicted joints;
        </Paragraph>
        <Paragraph>vi. persistent pain;</Paragraph>
        <Paragraph>vii. required muscle rehabilitation; or</Paragraph>
        <Paragraph>viii. suspicion of any heart condition,</Paragraph>

        <Paragraph>
          2.3 By accessing the Katalyst Training System, you affirm and
          represent that either (a) none of 2.2(a) through (i) are true or
          otherwise apply to you, or (b) your general practitioner or other
          qualified medical professional has been consulted and has approved
          your use of the Katalyst Training System.
        </Paragraph>

        <Paragraph>
          2.4 YOU ACKNOWLEDGE AND AGREE THAT KATALYST IS NOT A HEALTH CARE
          ORGANIZATION, AND ITS WORKOUT CONTENT AND EXERCISES OR ANY OTHER
          INFORMATION PROVIDED BY THE KATALYST TRAINING SYSTEM OR ANY KATALYST
          EMPLOYEES OR REPRESENTATIVES DOES NOT CONSTITUTE MEDICAL ADVICE,
          TREATMENT, PRESCRIPTIONS, OR DIAGNOSES. KATALYST AND ITS EMPLOYEES AND
          REPRESENTATIVES ARE NOT QUALIFIED PHYSICIANS AND CANNOT SAY WHETHER
          YOU ARE HEALTHY ENOUGH TO TAKE PART IN THE KATALYST TRAINING PLATFORM.
          YOU, IN CONSULTATION WITH YOUR OWN CHOSEN, QUALIFIED MEDICAL
          PROFESSIONALS, ARE SOLELY RESPONSIBLE FOR MAKING THIS DETERMINATION,
          AND YOU HEREBY AGREE TO EXPRESSLY ASSUME AND ACCEPT ANY AND ALL RISKS
          AND RESPONSIBILITY OF INJURY, PHYSICAL HARM OR DEATH, TO THE MAXIMUM
          EXTENT PERMITTED BY LAW.
        </Paragraph>

        <Paragraph>
          You should discontinue exercise in cases where it causes pain or
          severe discomfort and should consult a medical professional prior to
          returning to exercise in such cases. IF YOU THINK YOU MAY HAVE A
          MEDICAL EMERGENCY, CALL 911 IMMEDIATELY.
        </Paragraph>

        <Paragraph>
          2.5 Your Safety. By accessing the Katalyst Training System, you affirm
          and represent that you have read, understand, and will comply with the
          Katalyst Training System safety instructions and manual available at
          katalyst.fit/instructions (the “Katalyst Instruction Manual”), and any
          other safety or operating instructions provided by Katalyst from time
          to time.
        </Paragraph>

        <Paragraph>
          2.6 Third-Party Equipment. Except as expressly provided for in the
          Katalyst Instruction Manual or otherwise through the Services the
          Katalyst Training System is not intended for use with any third party
          equipment or any third-party training content. YOUR USE OF ANY THIRD
          PARTY EQUIPMENT OR TRAINING CONTENT IS WHOLLY AT YOUR OWN
          RISK.Accounts and Registration. To access most features of the
          Services, you must register for an account (“Katalyst Account”). When
          you register for a Katalyst Account, you may be required to provide us
          with some information about yourself, such as your name, email
          address, or other contact information. You agree that the information
          you provide to us is accurate and that you will keep it accurate and
          up-to-date at all times. When you register, you will be asked to
          provide a password. You are solely responsible for maintaining the
          confidentiality of your account and password, and you accept
          responsibility for all activities that occur under your account. If
          you believe that your account is no longer secure, then you must
          immediately notify us at support@katalyst.fit
        </Paragraph>

        <Paragraph>
          3.1 Membership Holder and Members. A “Member” is any individual who
          has a Katalyst account. A “Membership Holder” is any Member who
          activates and pays the Subscription Fees (as defined below) for a
          Subscription Service.
        </Paragraph>

        <Paragraph>
          3.2 Multiple Members. As a Membership Holder, you may activate one or
          more Members on each Subscription Service. Each Member must register
          for their own Katalyst Account, and accept these Terms. Katalyst may
          impose restrictions on the number of streams that can occur
          simultaneously under a single Subscription Service or the maximum
          number of Members per Subscription Service. The Membership Holder is
          responsible for all activity under their Subscription Service.General
          Purchase Terms.
        </Paragraph>

        <Paragraph>
          4.1 Availability. Purchases of the Component are subject to estimated
          availability and availability is not guaranteed. Katalyst reserves the
          right to impose quantity limitations on any order.
        </Paragraph>

        <Paragraph>
          4.2 Price. Before you pay any fees, you will have an opportunity to
          review and accept the fees that you will be charged. All fees are in
          U.S. Dollars and exclude any applicable shipping and handling, taxes
          and other applicable charges (if any). Except as set forth in Section
          4.8, all fees are non-refundable. Katalyst reserves the right to
          determine pricing for the Katalyst Training System. Katalyst will make
          reasonable efforts to keep pricing information published on the
          website up to date. We encourage you to check our website periodically
          for current pricing information. Katalyst may change the fees for any
          feature of the Service, including additional fees or charges, if
          Katalyst gives you advance notice of changes before they apply.
          Katalyst, at its sole discretion, may make promotional offers with
          different features and different pricing to any of Katalyst’s
          customers. These promotional offers, unless made to you, will not
          apply to your offer or these Terms. All orders for the Component must
          be paid in full, including shipping and handling, prior to delivery by
          Katalyst of the Component to you. Katalyst reserves the right to
          suspend delivery and performance until full payment is received.
        </Paragraph>

        <Paragraph>
          4.3 Authorization. You authorize Katalyst (and its third party
          providers, as applicable) to charge all sums for the orders that you
          make and any level of Service you select as described in these Terms
          or published by Katalyst, including all applicable taxes, to the
          payment method specified in your account. If you pay any fees with a
          credit card, Katalyst may seek pre-authorization of your credit card
          account prior to your purchase to verify that the credit card is valid
          and has the necessary funds or credit available to cover your
          purchase.
        </Paragraph>

        <Paragraph>
          4.4 Component Orders. Your order constitutes an offer to purchase a
          Component, and all orders are subject to Katalyst’s acceptance. Except
          to the extent prohibited by applicable law, Katalyst may accept,
          decline, or place limits on your order for any reason. You do,
          however, acknowledge that by clicking on the “Buy”, “Buy Now”,
          “Purchase”, “Pay Now” or other similar buttons, you enter into an
          obligation to pay for the Component. Your order is not complete until
          Katalyst informs you that your order has been confirmed and shipment
          is ready. If Katalyst rejects your offer, Katalyst will, as your sole
          and exclusive remedy and Katalyst’s sole and exclusive liability,
          refund the amount you paid as described in Section 4.8. Katalyst will
          send you an email to the address provided by you once the Component is
          ready for shipment to indicate whether your order has been confirmed.
          If you have any questions, comments, or concerns regarding Katalyst’s
          order acceptance policy, or if you believe that your order was
          rejected in error, please contact Katalyst at support@katalyst.fit.
        </Paragraph>

        <Paragraph>
          4.5 Title, Risk of Loss. Title to the Component will pass to you when
          the Component is delivered to the carrier, after which all risk of
          loss or damage to any Component will be yours, subject to any rights
          you may have under the limited warranty set forth in Section 14.1.
        </Paragraph>

        <Paragraph>
          4.6 Delivery. Katalyst will attempt in good faith to deliver the
          Component in accordance with your order or any other schedule Katalyst
          may provide to you when placing the order, but Katalyst will not be
          responsible or liable for any delays or failure in such delivery.
          Katalyst expressly reserves the right to effect delivery of the
          Component ordered in any number of separate shipments, and the modes
          of transport and carriers will be decided at Katalyst’s discretion.
          During any period of shortage, Katalyst may allocate its supply of the
          Component in any manner Katalyst deems appropriate. Your order will be
          delivered to the delivery address you specify when placing your order.
          If your delivery address is geographically remote or otherwise
          difficult to deliver to, it is possible that we may not be able to
          deliver there. If that is the case, we will notify you before we
          accept your order. Orders cannot be delivered to PO Box or similar
          addresses. Katalyst will not be responsible or liable for any delay or
          failure to deliver due to any cause which is unavoidable or beyond
          Katalyst’s reasonable control. In such cases, Katalyst will have the
          right, at its option, without penalty or any liability for breach, to
          terminate all or any part of any order or to reschedule delivery
          within a reasonable time.
        </Paragraph>

        <Paragraph>
          4.7 Inspection. You should carefully examine all deliveries of the
          Component upon delivery, and notify Katalyst of any alleged error,
          shortage, defect or non-conformity of the Component within 5 days
          after receipt. Except as otherwise set forth in the limited warranty
          set forth in Section 14.1, your failure to examine and report will, to
          the maximum extent permitted by applicable law, constitute a waiver of
          any claim against Katalyst arising under these Terms or by law with
          respect to any such error, shortage, defect, or non-conformity
          reasonably discoverable by examination. You agree to make any and all
          claims for damage or loss in transit against the carrier.
        </Paragraph>

        <Paragraph>
          4.8 Returns and Refunds. Katalyst’s returns and refund policy is
          available at katalyst.fit/.
        </Paragraph>

        <Paragraph>
          4.9 Export Control. You acknowledge that the Component may be subject
          to export control laws and other laws and regulations of the United
          States and other countries, and that if Katalyst ships the Component
          to you, the Component may be impounded or otherwise confiscated by
          customs or other authorities. You are responsible for compliance with
          all applicable export control laws and regulations. You represent that
          you will not export, re-export, or transfer indirectly or directly any
          Component outside of the United States without obtaining proper
          authorization from the applicable government agencies. Without
          limiting the immediately preceding sentence, you will not export,
          re-export, or transfer directly or indirectly any Component to: (a) an
          embargoed/terrorist supporting country, including Cuba, Iran, North
          Korea, Syria, Sudan, or any other such country as determined by the
          U.S. government; (b) a person or entity barred by the U.S. Government
          on export activity lists, including persons or entities on the
          Treasury Department Specially Designated National List, Entities List,
          and Denied Persons List; or (c) any destination for an end use that is
          prohibited by applicable law. You will defend and hold Katalyst
          harmless against all claims, damages, or liability resulting from
          breach of the foregoing.
        </Paragraph>

        <Paragraph>
          4.10 Component Information; Changes. While we have taken reasonable
          steps to depict the Component as accurately as possible through the
          photographs and other images featured on our websites, the detailing
          (such as color, pattern and texture, etc.) you see on-screen will
          depend on your monitor and, as such, may not exactly reflect the
          actual detailing of a Component when you receive it. In addition,
          Katalyst expressly reserves the right, at any time and without notice,
          to discontinue the production or change the specifications of any
          Component or the Service.
        </Paragraph>

        <Paragraph>
          4.11 Subscription Service. The Service may include a membership
          subscription that includes automatically recurring payments for
          periodic charges (“Subscription Service”). If you activate a
          Subscription Service, you authorize Katalyst to periodically charge,
          on a going-forward basis and until cancellation of either the
          recurring payments or your account, all accrued sums on or before the
          payment due date for the accrued sums. The “Subscription Billing Date”
          is the date when you purchase your first subscription to the Service.
          For information on the “Subscription Fee”, please see our website at
          katalyst.fit. Your account will be charged automatically on the
          Subscription Billing Date all applicable fees and taxes for the next
          billing period (e.g., monthly billing periods will be billed on the
          same day each month). The subscription will continue unless and until
          you cancel your subscription or we terminate it. You must cancel your
          subscription before it renews in order to avoid billing of the next
          periodic Subscription Fee to your account. Your Subscription Fee will
          be billed to the payment method you provide to us during registration
          or the payment method associated with your applicable Apple iOS
          device. For Subscription Services paid for through your Apple iOS
          device, you may cancel the Subscription Service by following the steps
          described in this Apple support article
          support.apple.com/en-us/HT202039.
        </Paragraph>

        <Paragraph>
          4.12 Delinquent Accounts. Katalyst may suspend or terminate access to
          the Service, including fee-based portions of the Service, for any
          account for which any amount is due but unpaid. In addition to the
          amount due for the Service, a delinquent account will be charged with
          fees or charges that are incidental to any chargeback or collection of
          any unpaid amount, including collection fees. Licenses
        </Paragraph>

        <Paragraph>
          5.1 Limited License. Subject to your complete and ongoing compliance
          with these Terms, Katalyst grants you, solely for your personal,
          non-commercial use, a limited, non-exclusive, non-transferable,
          non-sublicensable, revocable license to: (a) install and use one
          object code copy of any mobile application associated with the Service
          obtained from a legitimate marketplace (whether installed by you or
          pre-installed on your mobile device by the device manufacturer) on a
          mobile device that you own or control; and (b) access and use the
          Service.
        </Paragraph>

        <Paragraph>
          5.2 License Restrictions. Except and solely to the extent such a
          restriction is impermissible under applicable law, you may not: (a)
          reproduce, distribute, publicly display, or publicly perform any
          portion of the Service; (b) make modifications to any portion of the
          Service; (c) access the Service (or any portion of the Service) in
          order to build a competitive or similar service; or (d) interfere with
          or circumvent any feature of the Service, including any security or
          access control mechanism. If you are prohibited under applicable law
          from using the Service, you may not use it.
        </Paragraph>

        <Paragraph>
          5.3 Feedback. If you choose to provide input and suggestions regarding
          problems with or proposed modifications or improvements to the
          Katalyst Training System (“Feedback”), then you hereby grant Katalyst
          an unrestricted, perpetual, irrevocable, non-exclusive, fully-paid,
          royalty-free right to exploit the Feedback in any manner and for any
          purpose, including to improve the Katalyst Training System and create
          other products and services.Ownership; Proprietary Rights. The
          Katalyst Training System is owned and operated by Katalyst. The
          videos, visual interfaces, graphics, design, compilation, information,
          data, computer code (including source code or object code), products,
          software, services, and all other elements of the Katalyst Training
          System, including any computer code installed on the Components
          (“Materials”) provided by Katalyst are protected by intellectual
          property and other laws. All Materials included in the Katalyst
          Training System are the property of Katalyst or its third party
          licensors. Transfer of title to the Components does not include any
          Materials included or embedded in the Component, which Materials are
          made available to you under a license from Katalyst. Except as
          expressly authorized by Katalyst, you may not make use of the
          Materials. Katalyst reserves all rights to the Materials not granted
          expressly in these Terms.Third Party Terms
        </Paragraph>

        <Paragraph>
          7.1 Third Party Services and Linked Websites. Katalyst may provide
          tools through the Service that enable you to export information to
          third party services, including through features that allow you to
          link your account on Katalyst with an account on the third party
          service, such as Spotify. By using one of these tools, you agree that
          Katalyst may transfer that information to the applicable third party
          service. Third party services are not under Katalyst’s control, and,
          to the fullest extent permitted by law, Katalyst is not responsible
          for any third party service’s use of your exported information. The
          Service may also contain links to third party websites. Linked
          websites are not under Katalyst’s control, and Katalyst is not
          responsible for their content.
        </Paragraph>

        <Paragraph>
          7.2 Third Party Software. The Katalyst Training System may include or
          incorporate third party software components that are generally
          available free of charge under licenses granting recipients broad
          rights to copy, modify, and distribute those components (“Third Party
          Components”). Although the Katalyst Training System is provided to you
          subject to these Terms, nothing in these Terms prevents, restricts, or
          is intended to prevent or restrict you from obtaining Third Party
          Components under the applicable third party licenses or to limit your
          use of Third Party Components under those third party licenses.
          Digital Millennium Copyright Act
        </Paragraph>

        <Paragraph>
          8.1 DMCA Notification. We comply with the provisions of the Digital
          Millennium Copyright Act applicable to Internet service providers (17
          U.S.C. §512, as amended). If you have an intellectual property
          rights-related complaint about material posted on the Service, you may
          contact our Designated Agent at the following address:
        </Paragraph>

        <Paragraph>Katalyst, Inc.</Paragraph>
        <Paragraph>ATTN: Legal Department (Copyright Notification)</Paragraph>
        <Paragraph>
          1201 3rd Ave., Suite 2200, Seattle, Washington, 98101
        </Paragraph>

        <Paragraph>Email: support@katalyst.fit</Paragraph>

        <Paragraph>
          Any notice alleging that materials hosted by or distributed through
          the Service infringe intellectual property rights must include the
          following information:
        </Paragraph>

        <Paragraph>
          a. an electronic or physical signature of the person authorized to act
          on behalf of the owner of the copyright or other right being
          infringed;
        </Paragraph>
        <Paragraph>
          b. a description of the copyrighted work or other intellectual
          property that you claim has been infringed;
        </Paragraph>
        <Paragraph>
          c. a description of the material that you claim is infringing and
          where it is located on the Service
        </Paragraph>

        <Paragraph>
          d. your address, telephone number, and email address;
        </Paragraph>

        <Paragraph>
          e. a statement by you that you have a good faith belief that the use
          of the materials on the Service of which you are complaining is not
          authorized by the copyright owner, its agent, or the law; and
        </Paragraph>

        <Paragraph>
          f. a statement by you that the above information in your notice is
          accurate and that, under penalty of perjury, you are the copyright or
          intellectual property owner or authorized to act on the copyright or
          intellectual property owner’s behalf.
        </Paragraph>

        <Paragraph>
          8.2 Repeat Infringers. Katalyst will promptly terminate the accounts
          of users that are determined by Katalyst to be repeat
          infringers.Communications
        </Paragraph>

        <Paragraph>
          9.1 Push Notifications. When you install our app on your mobile
          device, you agree to receive push notifications, which are messages an
          app sends you on your mobile device when the app is not on. You can
          turn off notifications by visiting your mobile device’s “settings”
          page.
        </Paragraph>

        <Paragraph>
          9.2 Email. We may send you emails concerning our products and
          services, as well as those of third parties. You may opt out of
          promotional emails by following the unsubscribe instructions in the
          promotional email itself. Prohibited Conduct. BY USING THE KATALYST
          TRAINING SYSTEM YOU AGREE NOT TO:
        </Paragraph>

        <Paragraph>
          a. use the Service for any illegal purpose or in violation of any
          local, state, national, or international law;
        </Paragraph>

        <Paragraph>
          b. violate, or encourage others to violate, any right of a third
          party, including by infringing or misappropriating any third party
          intellectual property right;
        </Paragraph>

        <Paragraph>
          c. interfere with security-related features of the Service, including
          by: (i) disabling or circumventing features that prevent or limit use
          or copying of any content; or (ii) reverse engineering or otherwise
          attempting to discover the source code of any portion of the Service
          except to the extent that the activity is expressly permitted by
          applicable law;
        </Paragraph>

        <Paragraph>
          d. interfere with the operation of the Service or any user’s enjoyment
          of the Service, including by: (i) uploading or otherwise disseminating
          any virus, adware, spyware, worm, or other malicious code; (ii) making
          any unsolicited offer or advertisement to another user of the Service;
          (iii) collecting personal information about another user or third
          party without consent; or (iv) interfering with or disrupting any
          network, equipment, or server connected to or used to provide the
          Service;
        </Paragraph>

        <Paragraph>
          e. perform any fraudulent activity including impersonating any person
          or entity, claiming a false affiliation, accessing any other Service
          account without permission, or falsifying your age or date of birth;
        </Paragraph>

        <Paragraph>
          f. sell or otherwise transfer the access granted under these Terms or
          any Materials (as defined in Section 6) or any right or ability to
          view, access, or use any Materials; or
        </Paragraph>

        <Paragraph>
          g. attempt to do any of the acts described in this Section 10 or
          assist or permit any person in engaging in any of the acts described
          in this Section 10.Modification of these Terms. We reserve the right
          to change these Terms on a going-forward basis at any time upon 7
          days’ notice. Please check these Terms periodically for changes. If a
          change to these Terms materially modifies your rights or obligations,
          we may require that you accept the modified Terms in order to continue
          to use the Service. Material modifications are effective upon
          expiration of such 7-day period or your acceptance of the modified
          Terms, whichever occurs first. Immaterial modifications are effective
          upon publication. Except as expressly permitted in this Section 11,
          these Terms may be amended only by a written agreement signed by
          authorized representatives of the parties to these Terms. Disputes
          arising under these Terms will be resolved in accordance with the
          version of these Terms that was in effect at the time the dispute
          arose. Term, Termination and Modification of the Service
        </Paragraph>

        <Paragraph>
          12.1 Term. These Terms are effective beginning when you accept the
          Terms or first download, install, access, or use the Service, and
          ending when terminated as described in Section 12.2.
        </Paragraph>

        <Paragraph>
          12.2 Termination. If you violate any provision of these Terms, your
          authorization to access the Service and these Terms automatically
          terminate. In addition, Katalyst may, at its sole discretion,
          terminate these Terms or your account on the Service, or suspend or
          terminate your access to the Service, at any time for any reason or no
          reason, with or without notice. You may terminate your Katalyst
          Account and these Terms at any time by contacting customer service at
          support@katalyst.fit.
        </Paragraph>

        <Paragraph>
          12.3 Effect of Termination. Upon termination of these Terms: (a) your
          license rights will terminate and you must immediately cease all use
          of the Service; (b) you will no longer be authorized to access your
          Katalyst Account or the Service; (c) you must pay Katalyst any unpaid
          amount that was due prior to termination; and (d) all payment
          obligations accrued prior to termination and Sections 5.3, 6, 12.3,
          13, 14.3, 15, 15 and 16 will survive.
        </Paragraph>

        <Paragraph>
          12.4 Modification of the Service. Katalyst reserves the right to
          modify or discontinue the Service at any time (including by limiting
          or discontinuing certain features of the Service), temporarily or
          permanently, without notice to you. Except as otherwise set forth in
          our return and refund policy at katalyst.fit, Katalyst will have no
          liability for any change to the Service or any suspension or
          termination of your access to or use of the Service. Indemnity. To the
          fullest extent permitted by law, you are responsible for your use of
          the Katalyst Training System, and you will defend and indemnify
          Katalyst and its officers, directors, employees, consultants,
          affiliates, subsidiaries and agents (together, the “Katalyst
          Entities”) from and against every claim brought by a third party, and
          any related liability, damage, loss, and expense, including reasonable
          attorneys’ fees and costs, arising out of or connected with: (a) your
          unauthorized use of, or misuse of, the Katalyst Training System; (b)
          your violation of any portion of these Terms, any representation,
          warranty, or agreement referenced in these Terms, or any applicable
          law or regulation; (c) your violation of any third party right,
          including any intellectual property right or publicity,
          confidentiality, other property, or privacy right; or (d) any dispute
          or issue between you and any third party. We reserve the right, at our
          own expense, to assume the exclusive defense and control of any matter
          otherwise subject to indemnification by you (without limiting your
          indemnification obligations with respect to that matter), and in that
          case, you agree to cooperate with our defense of those
          claims.Warranties and Disclaimers
        </Paragraph>

        <Paragraph>
          14.1 Limited Warranty for Components. Please carefully review the
          limited warranty for Components, available at katalyst.fit/warranty,
          before making a purchase decision.
        </Paragraph>

        <Paragraph>
          14.2 No Warranty for Modified Components. If you modify a Component,
          please be aware that your modification may cause loss of access to the
          Service or loss of some or all functionality of your Component. In
          addition, modification of your Component voids the limited warranty.
        </Paragraph>

        <Paragraph>
          14.3 Disclaimer. THE KATALYST TRAINING SYSTEM AND ALL MATERIALS AND
          CONTENT AVAILABLE THROUGH THE KATALYST TRAINING SYSTEM ARE PROVIDED
          “AS IS” AND ON AN “AS AVAILABLE” BASIS. KATALYST DISCLAIMS ALL
          WARRANTIES OF ANY KIND, WHETHER EXPRESS OR IMPLIED, RELATING TO THE
          KATALYST TRAINING SYSTEM AND ALL MATERIALS AND CONTENT AVAILABLE
          THROUGH THE KATALYST TRAINING SYSTEM, INCLUDING: (A) ANY IMPLIED
          WARRANTY OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, TITLE,
          QUIET ENJOYMENT, OR NON-INFRINGEMENT; AND (B) ANY WARRANTY ARISING OUT
          OF COURSE OF DEALING, USAGE, OR TRADE. KATALYST DOES NOT WARRANT THAT
          THE KATALYST TRAINING SYSTEM OR ANY PORTION OF THE KATALYST TRAINING
          SYSTEM, OR ANY MATERIALS OR CONTENT OFFERED THROUGH THE KATALYST
          TRAINING SYSTEM, WILL BE UNINTERRUPTED, SECURE, OR FREE OF ERRORS,
          VIRUSES, OR OTHER HARMFUL COMPONENTS, AND KATALYST DOES NOT WARRANT
          THAT ANY OF THOSE ISSUES WILL BE CORRECTED.
        </Paragraph>

        <Paragraph>
          NO ADVICE OR INFORMATION, WHETHER ORAL OR WRITTEN, OBTAINED BY YOU
          FROM THE KATALYST TRAINING SYSTEM OR KATALYST ENTITIES OR ANY
          MATERIALS OR CONTENT AVAILABLE THROUGH THE KATALYST TRAINING SYSTEM
          WILL CREATE ANY WARRANTY REGARDING ANY OF THE KATALYST ENTITIES OR THE
          KATALYST TRAINING SYSTEM THAT IS NOT EXPRESSLY STATED IN THESE TERMS.
          WE ARE NOT RESPONSIBLE FOR ANY DAMAGE THAT MAY RESULT FROM THE
          KATALYST TRAINING SYSTEM AND YOUR DEALING WITH ANY OTHER SERVICE USER.
          YOU UNDERSTAND AND AGREE THAT YOU USE ANY PORTION OF THE KATALYST
          TRAINING SYSTEM AT YOUR OWN DISCRETION AND RISK, AND THAT WE ARE NOT
          RESPONSIBLE FOR ANY DAMAGE TO YOUR PROPERTY CAUSED BY THE KATALYST
          TRAINING SYSTEM, OR ANY LOSS OF DATA, INCLUDING USER CONTENT.
        </Paragraph>

        <Paragraph>
          THE LIMITATIONS, EXCLUSIONS, AND DISCLAIMERS IN THIS SECTION APPLY TO
          THE FULLEST EXTENT PERMITTED BY LAW. Katalyst does not disclaim any
          warranty or other right that Katalyst is prohibited from disclaiming
          under applicable law.Limitation of Liability
        </Paragraph>
        <Paragraph>
          TO THE FULLEST EXTENT PERMITTED BY LAW, IN NO EVENT WILL THE KATALYST
          ENTITIES BE LIABLE TO YOU FOR ANY INDIRECT, INCIDENTAL, SPECIAL,
          CONSEQUENTIAL OR PUNITIVE DAMAGES (INCLUDING DAMAGES FOR LOSS OF
          PROFITS, GOODWILL, OR ANY OTHER INTANGIBLE LOSS) ARISING OUT OF OR
          RELATING TO YOUR ACCESS TO OR USE OF, OR YOUR INABILITY TO ACCESS OR
          USE, THE KATALYST TRAINING SYSTEM OR ANY MATERIALS OR CONTENT ON THE
          KATALYST TRAINING SYSTEM, WHETHER BASED ON WARRANTY, CONTRACT, TORT
          (INCLUDING NEGLIGENCE), STATUTE, OR ANY OTHER LEGAL THEORY, AND
          WHETHER OR NOT ANY KATALYST ENTITY HAS BEEN INFORMED OF THE
          POSSIBILITY OF DAMAGE.
        </Paragraph>

        <Paragraph>
          EXCEPT AS PROVIDED IN SECTION 16.5 AND TO THE FULLEST EXTENT PERMITTED
          BY LAW, (A) THE AGGREGATE LIABILITY OF THE KATALYST ENTITIES TO YOU
          FOR ALL CLAIMS ARISING OUT OF OR RELATING TO THE USE OF OR ANY
          INABILITY TO USE ANY PORTION OF THE SERVICE OR OTHERWISE UNDER THESE
          TERMS, WHETHER IN CONTRACT, TORT, OR OTHERWISE, IS LIMITED TO THE
          GREATER OF: (I) THE AMOUNT YOU HAVE PAID TO KATALYST FOR ACCESS TO AND
          USE OF THE SERVICE IN THE 12 MONTHS PRIOR TO THE EVENT OR CIRCUMSTANCE
          GIVING RISE TO CLAIM; AND (II) $100; AND (B) THE AGGREGATE LIABILITY
          OF KATALYST TO YOU FOR ALL CLAIMS ARISING OUT OF OR RELATING TO THE
          USE OF OR ANY INABILITY TO USE ANY COMPONENT, WHETHER IN CONTRACT,
          TORT, OR OTHERWISE, IS LIMITED TO THE AMOUNT YOU PAID TO KATALYST FOR
          THAT COMPONENT.
        </Paragraph>

        <Paragraph>
          EACH PROVISION OF THESE TERMS THAT PROVIDES FOR A LIMITATION OF
          LIABILITY, DISCLAIMER OF WARRANTIES, OR EXCLUSION OF DAMAGES IS
          INTENDED TO AND DOES ALLOCATE THE RISKS BETWEEN THE PARTIES UNDER
          THESE TERMS. THIS ALLOCATION IS AN ESSENTIAL ELEMENT OF THE BASIS OF
          THE BARGAIN BETWEEN THE PARTIES. EACH OF THESE PROVISIONS IS SEVERABLE
          AND INDEPENDENT OF ALL OTHER PROVISIONS OF THESE TERMS. THE
          LIMITATIONS IN THIS SECTION 15 WILL APPLY EVEN IF ANY LIMITED REMEDY
          FAILS OF ITS ESSENTIAL PURPOSE.Dispute Resolution and Arbitration
        </Paragraph>

        <Paragraph>
          16.1 Generally. In the interest of resolving disputes between you and
          Katalyst in the most expedient and cost-effective manner, and except
          as described in Section 16.2 and 16.3, you and Katalyst agree that
          every dispute arising in connection with these Terms (including any
          dispute arising from your purchase or use of a Component) will be
          resolved by binding arbitration. Arbitration is less formal than a
          lawsuit in court. Arbitration uses a neutral arbitrator instead of a
          judge or jury, may allow for more limited discovery than in court and
          can be subject to very limited review by courts. Arbitrators can award
          the same damages and relief that a court can award. This agreement to
          arbitrate disputes includes all claims arising out of or relating to
          any aspect of these Terms, whether based in contract, tort, statute,
          fraud, misrepresentation, or any other legal theory and regardless of
          whether a claim arises during or after the termination of these Terms.
          YOU UNDERSTAND AND AGREE THAT, BY ENTERING INTO THESE TERMS, YOU AND
          KATALYST ARE EACH WAIVING THE RIGHT TO A TRIAL BY JURY OR TO
          PARTICIPATE IN A CLASS ACTION.
        </Paragraph>

        <Paragraph>
          16.2 Exceptions. Despite the provisions of Section 16.1, nothing in
          these Terms will be deemed to waive, preclude, or otherwise limit the
          right of either party to: (a) bring an individual action in small
          claims court; (b) pursue an enforcement action through the applicable
          federal, state, or local agency if that action is available; (c) seek
          injunctive relief in a court of law in aid of arbitration; or (d) to
          file suit in a court of law to address an intellectual property
          infringement claim.
        </Paragraph>

        <Paragraph>
          16.3 Opt-Out. If you do not wish to resolve disputes by binding
          arbitration, you may opt out of the provisions of this Section 16
          within 30 days after the date that you agree to these Terms by sending
          a letter to Katalyst, Inc., Attention: Legal Department – Arbitration
          Opt-Out, 1201 3rd Ave., Suite 2200, Seattle, Washington, 98101 that
          specifies: your full legal name, the email address associated with
          your account on the Service, and a statement that you wish to opt out
          of arbitration (“Opt-Out Notice”). Once Katalyst receives your Opt-Out
          Notice, this Section 16 will be void and any action arising out of
          these Terms will be resolved as set forth in Section 17.2. The
          remaining provisions of these Terms will not be affected by your
          Opt-Out Notice.
        </Paragraph>

        <Paragraph>
          16.4 Arbitrator. Any arbitration between you and Katalyst will be
          settled under the Federal Arbitration Act and administered by the
          American Arbitration Association (“AAA”) under its Consumer
          Arbitration Rules (collectively, “AAA Rules”) as modified by these
          Terms. The AAA Rules and filing forms are available online at
          www.adr.org, by calling the AAA at 1-800-778-7879, or by contacting
          Katalyst. The arbitrator has exclusive authority to resolve any
          dispute relating to the interpretation, applicability, or
          enforceability of this binding arbitration agreement.
        </Paragraph>

        <Paragraph>
          16.5 Notice of Arbitration; Process. A party who intends to seek
          arbitration must first send a written notice of the dispute to the
          other party by certified U.S. Mail or by Federal Express (signature
          required) or, only if that other party has not provided a current
          physical address, then by electronic mail (“Notice of Arbitration”).
          Katalyst’s address for Notice is Katalyst, Inc., 1201 3rd Ave., Suite
          2200, Seattle, Washington, 98101. The Notice of Arbitration must: (a)
          describe the nature and basis of the claim or dispute; and (b) set
          forth the specific relief sought (“Demand”). The parties will make
          good faith efforts to resolve the claim directly, but if the parties
          do not reach an agreement to do so within 30 days after the Notice of
          Arbitration is received, you or Katalyst may commence an arbitration
          proceeding. All arbitration proceedings between the parties will be
          confidential unless otherwise agreed by the parties in writing. During
          the arbitration, the amount of any settlement offer made by you or
          Katalyst must not be disclosed to the arbitrator until after the
          arbitrator makes a final decision and award, if any. If the arbitrator
          awards you an amount higher than the last written settlement amount
          offered by Katalyst in settlement of the dispute prior to the award,
          Katalyst will pay to you the higher of: (i) the amount awarded by the
          arbitrator; or (ii) $10,000.
        </Paragraph>

        <Paragraph>
          16.6 Fees. If you commence arbitration in accordance with these Terms,
          Katalyst will reimburse you for your payment of the filing fee, unless
          your claim is for more than $10,000, in which case the payment of any
          fees will be decided by the AAA Rules. Any arbitration hearing will
          take place at a location to be agreed upon in King County, Washington
          but if the claim is for $10,000 or less, you may choose whether the
          arbitration will be conducted: (a) solely on the basis of documents
          submitted to the arbitrator; (b) through a non-appearance based
          telephone hearing; or (c) by an in-person hearing as established by
          the AAA Rules in the county (or parish) of your billing address. If
          the arbitrator finds that either the substance of your claim or the
          relief sought in the Demand is frivolous or brought for an improper
          purpose (as measured by the standards set forth in Federal Rule of
          Civil Procedure 11(b)), then the payment of all fees will be governed
          by the AAA Rules. In that case, you agree to reimburse Katalyst for
          all monies previously disbursed by it that are otherwise your
          obligation to pay under the AAA Rules. Regardless of the manner in
          which the arbitration is conducted, the arbitrator must issue a
          reasoned written decision sufficient to explain the essential findings
          and conclusions on which the decision and award, if any, are based.
          The arbitrator may make rulings and resolve disputes as to the payment
          and reimbursement of fees or expenses at any time during the
          proceeding and upon request from either party made within 14 days of
          the arbitrator’s ruling on the merits.
        </Paragraph>

        <Paragraph>
          16.7 No Class Actions. YOU AND KATALYST AGREE THAT EACH MAY BRING
          CLAIMS AGAINST THE OTHER ONLY IN YOUR OR ITS INDIVIDUAL CAPACITY AND
          NOT AS A PLAINTIFF OR CLASS MEMBER IN ANY PURPORTED CLASS OR
          REPRESENTATIVE PROCEEDING. Further, unless both you and Katalyst agree
          otherwise, the arbitrator may not consolidate more than one person’s
          claims, and may not otherwise preside over any form of a
          representative or class proceeding.
        </Paragraph>

        <Paragraph>
          16.8 Modifications to this Arbitration Provision. If Katalyst makes
          any future change to this arbitration provision, other than a change
          to Katalyst’s address for Notice of Arbitration, you may reject the
          change by sending us written notice within 30 days of the change to
          Katalyst’s address for Notice of Arbitration, in which case your
          account with Katalyst will be immediately terminated and this
          arbitration provision, as in effect immediately prior to the changes
          you rejected will survive.
        </Paragraph>

        <Paragraph>
          16.9 Enforceability. If Section 16.7 or the entirety of this Section
          16 is found to be unenforceable, or if Katalyst receives an Opt-Out
          Notice from you, then the entirety of this Section 16 will be null and
          void and, in that case, the exclusive jurisdiction and venue described
          in Section 16.2 will govern any action arising out of or related to
          these Terms.Miscellaneous
        </Paragraph>

        <Paragraph>
          17.1 General Terms. These Terms, together with the Privacy Policy and
          any other agreements expressly incorporated by reference into these
          Terms, are the entire and exclusive understanding and agreement
          between you and Katalyst regarding your use of the Service and
          purchase of a Component. You may not assign or transfer these Terms or
          your rights under these Terms, in whole or in part, by operation of
          law or otherwise, without our prior written consent. We may assign
          these Terms at any time without notice or consent. The failure to
          require performance of any provision will not affect our right to
          require performance at any other time after that, nor will a waiver by
          us of any breach or default of these Terms, or any provision of these
          Terms, be a waiver of any subsequent breach or default or a waiver of
          the provision itself. The use of section headers in these Terms is for
          convenience only and will not have any impact on the interpretation of
          any provision. Throughout these Terms, the use of the word “including”
          means “including but not limited to”. If any part of these Terms is
          held to be invalid or unenforceable, the unenforceable part will be
          given effect to the greatest extent possible, and the remaining parts
          will remain in full force and effect.
        </Paragraph>

        <Paragraph>
          17.2 Governing Law. These Terms are governed by the laws of the State
          of Washington without regard to conflict of law principles. You and
          Katalyst submit to the personal and exclusive jurisdiction of the
          state courts and federal courts located within King County, Washington
          for resolution of any lawsuit or court proceeding permitted under
          these Terms. We operate the Service from our offices in Washington,
          and we make no representation that Materials included in the Katalyst
          Training System are appropriate or available for use in other
          locations.
        </Paragraph>

        <Paragraph>
          17.3 Privacy Policy. Please read the Katalyst Privacy Policy at
          katalyst.fit/privacy carefully for information relating to our
          collection, use, storage, disclosure of your personal information. The
          Katalyst Privacy Policy is incorporated by this reference into, and
          made a part of, these Terms.
        </Paragraph>

        <Paragraph>
          17.4 Additional Terms. Your use of the Katalyst Training System is
          subject to all additional terms, policies, rules, or guidelines
          applicable to the Katalyst Training System or certain features of the
          Katalyst Training System that we may post on or link to from the
          Service (the “Additional Terms”). All Additional Terms are
          incorporated by this reference into, and made a part of, these Terms.
        </Paragraph>

        <Paragraph>
          17.5 Force Majeure. Katalyst will not be liable to you for any delay
          in delivery of the Component or your inability to access the Service,
          including any delay or lack of access due to an event beyond
          Katalyst’s reasonable control, such as an act of God, terrorism, war,
          political insurgence, insurrection, riot, civil unrest, act of civil
          or military authority, uprising, earthquake, flood or any other
          natural or man-made condition outside of Katalyst’s control. We will
          not be liable or responsible for any failure to perform, or delay in
          performance of, any of our obligations under these Terms or any order
          that is caused by events outside our reasonable control.
        </Paragraph>

        <Paragraph>
          17.6 Consent to Electronic Communications. By using the Katalyst
          Training System, you consent to receiving certain electronic
          communications from us as further described in our Privacy Policy.
          Please read our Privacy Policy to learn more about our electronic
          communications practices. You agree that any notices, agreements,
          disclosures, or other communications that we send to you
          electronically will satisfy any legal communication requirements,
          including that those communications be in writing.
        </Paragraph>

        <Paragraph>
          17.7 Contact Information. The Katalyst Training System is offered by
          Katalyst, Inc., located at 1201 3rd Ave., Suite 2200, Seattle,
          Washington, 98101. You may contact us by sending correspondence to
          that address or by emailing us at support@katalyst.fit.
        </Paragraph>

        <Paragraph>
          17.8 Notice to California Residents. If you are a California resident,
          under California Civil Code Section 1789.3, you may contact the
          Complaint Assistance Unit of the Division of Consumer Services of the
          California Department of Consumer Affairs in writing at 1625 N. Market
          Blvd., Suite S-202, Sacramento, California 95834, or by telephone at
          (800) 952-5210 in order to resolve a complaint regarding the Katalyst
          Training System or to receive further information regarding use of the
          Katalyst Training System.
        </Paragraph>

        <Paragraph>
          17.9 No Support. You may request support for the Katalyst Training
          System, including any problems with the Component, by contacting us at
          support@katalyst.fit. We are under no obligation to provide support
          for the Katalyst Training System. In instances where we may offer
          support, the support will be subject to published policies.
        </Paragraph>

        <Paragraph>
          17.10 International Use. The Katalyst Training System is intended for
          visitors located within the United States. We make no representation
          that the Katalyst Training System is appropriate or available for use
          outside of the United States. Access to the Katalyst Training System
          from countries or territories or by individuals where such access is
          illegal is prohibited.Notice Regarding Apple. This Section 18 only
          applies to the extent you are using our mobile application on an iOS
          device. You acknowledge that these Terms are between you and Katalyst
          only, not with Apple Inc. (“Apple”), and Apple is not responsible for
          the Service or the content thereof. Apple has no obligation to furnish
          any maintenance and support services with respect to the Service. If
          the Service fails to conform to any applicable warranty, you may
          notify Apple and Apple will refund any applicable purchase price for
          the mobile application to you; and, to the maximum extent permitted by
          applicable law, Apple has no other warranty obligation with respect to
          the Service. Apple is not responsible for addressing any claims by you
          or any third party relating to the Service or your possession and/or
          use of the Service, including: (a) product liability claims; (b) any
          claim that the Service fails to conform to any applicable legal or
          regulatory requirement; or (c) claims arising under consumer
          protection or similar legislation. Apple is not responsible for the
          investigation, defense, settlement and discharge of any third party
          claim that the Service and/or your possession and use of the Service
          infringe a third party’s intellectual property rights. You agree to
          comply with any applicable third party terms when using the Service.
          Apple and Apple’s subsidiaries are third party beneficiaries of these
          Terms, and upon your acceptance of these Terms, Apple will have the
          right (and will be deemed to have accepted the right) to enforce these
          Terms against you as a third party beneficiary of these Terms. You
          hereby represent and warrant that: (i) you are not located in a
          country that is subject to a U.S. Government embargo, or that has been
          designated by the U.S. Government as a “terrorist supporting” country;
          and (ii) you are not listed on any U.S. Government list of prohibited
          or restricted parties.
        </Paragraph>
      </Wrapper>
    </TermsOfUsePageContainer>
  </>
)

export default TermsOfUsePage
